import { Component, OnInit } from '@angular/core';
import { DivisionService } from '../Services/division.service';
import { AuthService } from '../Services/auth.service';
import { SharedService } from '../Services/shared.service';
import { Router } from '@angular/router';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {
  logininfo: Logininfo = this.AuthService.loginID;
  divisions;
  users_list;
  view_list;

  name;
  division;
  address;

  constructor(
    private router: Router,
    private divisionService: DivisionService,
    public AuthService: AuthService,
    private SharedService: SharedService
  ) { }

  ngOnInit() {
    this.division = "all";
    this.divisionService.getDivisionList().subscribe(result => {
      this.divisions = result;
    });
    this.AuthService.getUserList(0).subscribe(result => {
      this.users_list = result;
      this.search();
    });

  }

  edit(user) {
    //this.SharedService.setData(user);
    if (user) {
      this.router.navigate(['/user-register/' + user.user_code]);
    } else {
      this.router.navigate(['/user-register']);
    }
  }

  search() {
    this.view_list = this.users_list;
    if (this.name) {
      this.view_list = this.view_list.filter((item) => {
        let name = item.user_family_name + item.user_name;
        if (name.indexOf(this.name) > -1)
          return true;
      });

    }
    if (this.division != 'all') {
      this.view_list = this.view_list.filter((item) => {
        return item.division_code == this.division;
      });
    }
    if (this.address) {
      this.view_list = this.view_list.filter((item) => {
        if (item.mail_address.indexOf(this.address) > -1)
          return true;
      });
    }
  }

}
